import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const tabbedMediaCardBlockFields = `
  _id,
  _type,
  title,
  showTitle,
  backgroundColor,
  tabs[]{
    _type,
    label,
    image {
      ${imageFields}
    },
    body[]
  }
`

export const TABBED_MEDIA_CARD_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "tabbed-media-card-block"][0]{
    ${tabbedMediaCardBlockFields}
  }
`)
